import { Reveal } from "../landing/Reveal";

const MONETIZE = [
  { emoji: "🎥", label: "Reels" },
  { emoji: "📚", label: "Courses" },
  { emoji: "🛍️", label: "Products" },
  { emoji: "💰", label: "Referrals" },
  { emoji: "✈️", label: "Travel Deals" },
  { emoji: "🍔", label: "Food Reviews" },
];

export const CreatorHub = () => (
  <section id="creator-hub" data-testid="creator-hub-section" className="relative overflow-hidden py-20 sm:py-24">
    <div aria-hidden="true" className="absolute -right-32 top-1/4 h-[380px] w-[380px] rounded-full bg-[#F97316]/10 blur-[130px]" />
    <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-2">
        <Reveal>
          <p className="font-jbmono text-xs uppercase tracking-[0.3em] text-[#22C55E]">🧑‍💻 Creator Hub</p>
          <h2 className="mt-3 font-display text-3xl font-extrabold tracking-tight text-white sm:text-4xl lg:text-5xl">
            Student creators monetize everything.
          </h2>
          <p className="mt-4 max-w-md text-base leading-relaxed text-slate-400">
            If you can make it, you can earn from it — one dashboard, zero gatekeepers.
          </p>
          <div className="mt-8 grid grid-cols-2 gap-3 sm:grid-cols-3">
            {MONETIZE.map((m) => (
              <div
                key={m.label}
                data-testid={`monetize-${m.label.toLowerCase().replace(" ", "-")}`}
                className="flex items-center gap-2.5 rounded-2xl border border-white/10 bg-white/[0.04] px-4 py-3.5 backdrop-blur-xl transition-colors hover:border-[#22C55E]/50"
              >
                <span className="text-xl">{m.emoji}</span>
                <span className="text-sm font-semibold text-slate-200">{m.label}</span>
              </div>
            ))}
          </div>
        </Reveal>

        <Reveal delay={0.12}>
          <div className="rounded-[2rem] border border-white/10 bg-white/[0.04] p-7 backdrop-blur-xl sm:p-8" data-testid="creator-earnings">
            <p className="font-jbmono text-[10px] uppercase tracking-[0.25em] text-slate-400">
              Creator Dashboard · This Month
            </p>
            <p className="mt-3 font-display text-5xl font-black tracking-tight text-white">
              ₹42,380
            </p>
            <p className="mt-1 font-jbmono text-xs text-[#06B6D4]">▲ 31% vs last month</p>
            <div className="mt-6 space-y-3">
              {[
                { src: "🎥 Reels", amt: "₹18,200", w: "76%" },
                { src: "📚 Courses", amt: "₹12,480", w: "52%" },
                { src: "💰 Referrals", amt: "₹8,700", w: "36%" },
                { src: "🛍️ Products", amt: "₹3,000", w: "14%" },
              ].map((r) => (
                <div key={r.src}>
                  <div className="mb-1.5 flex justify-between text-xs">
                    <span className="text-slate-300">{r.src}</span>
                    <span className="font-jbmono text-[#06B6D4]">{r.amt}</span>
                  </div>
                  <div className="h-1.5 w-full overflow-hidden rounded-full bg-white/5">
                    <div className="h-full rounded-full bg-gradient-to-r from-[#7C3AED] to-[#06B6D4]" style={{ width: r.w }} />
                  </div>
                </div>
              ))}
            </div>
            <p className="mt-5 text-center font-jbmono text-[10px] uppercase tracking-widest text-slate-600">
              Demo dashboard — figures are illustrative
            </p>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
